import { z } from 'zod';

import { schemaEuropaceRatenschutzAbsicherung } from './RatenschutzAbsicherung.schema';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#finanzbedarfratenschutz

    {
        arbeitslosigkeitAbsicherung: RatenschutzAbsicherung,
        arbeitsunfaehigkeitAbsicherung: RatenschutzAbsicherung,
        todesfallAbsicherung: RatenschutzAbsicherung
    }

*/
export const schemaEuropaceFinanzbedarfRatenschutz = z.object({
    arbeitslosigkeitAbsicherung: z.optional(schemaEuropaceRatenschutzAbsicherung),
    arbeitsunfaehigkeitAbsicherung: z.optional(schemaEuropaceRatenschutzAbsicherung),
    todesfallAbsicherung: z.optional(schemaEuropaceRatenschutzAbsicherung),
});

export type SchemaEuropaceFinanzbedarfRatenschutz = z.infer<typeof schemaEuropaceFinanzbedarfRatenschutz>;
